export const zIndexManageUsersActionButton = 2;
export const zIndexKioskFooter = 9999;
export const zIndexPopup = 1300;
export const zIndexEmojiPickerLabel = 2;
